<template>
    <div class="ml-image">
        <div :style="{ backgroundImage: 'url(' + src + ')' }"></div>
    </div>
</template>

<script>
export default {
    props: ["src"]
};
</script>

<style lang="scss" scoped>
.ml-image {
    height: 100%;
    width: 100%;

    div {
        height: 100%;
        width: 100%;
        background-size: cover;
        background-position: 50%;
    }
}
</style>
